import { useCallback } from 'react';

import { ValidationService } from '../services/validation';

import type { CycleCallback, ValidationResult } from '../types';

export function useTimelineValidation(videoDuration: number, allowBilateral = true, allowOverlap = false) {
	const validateCycles = useCallback(
		(cycles: CycleCallback[]): ValidationResult => {
			return ValidationService.validateCycleCallbacks(cycles, videoDuration, allowBilateral, allowOverlap);
		},
		[videoDuration, allowBilateral, allowOverlap]
	);

	return { validateCycles };
}
